import { render, staticRenderFns } from "./OdontogramaDibujos.vue?vue&type=template&id=9f7683e4"
import script from "./OdontogramaDibujos.vue?vue&type=script&lang=js"
export * from "./OdontogramaDibujos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports